import React from "react";

import { FormattedMessage } from "react-intl";

import Tag from "ds/Tag";
import { useTrialInfo } from "Reducers/organization/hooks/useTrialnfo";

export const TrialTag = () => {
  const { config, isTrial } = useTrialInfo();
  const { tagText, tagVariant = "rose" } = config;

  if (!isTrial) return null;

  return (
    <Tag variant={tagVariant}>
      <FormattedMessage id={`trial_state.${tagText}`} />
    </Tag>
  );
};
